<div class="loading-screen-wrapper">
  <div class="spinner"></div>
</div>
